import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Sticky } from 'react-sticky';
import UnifiedNavHtmlLoader from '../UnifiedNavHtmlLoader';
import * as UserActions from '../../../../actions/UserActions';
import { getNav } from '../../../../actions/NavActions';

// make sure this website nav gets loaded in a <StickyContainer/>
/**
 * This component is only being used on the Public Registry page for the cart modal, but is pulling in the full nav bundle.
 */
class UnifiedNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav: '',
      height: window.innerWidth < 992 ? 60 : 110,
    };

    this.refreshNavHeight = this.refreshNavHeight.bind(this);
  }

  componentDidMount() {
    const { user, getUserContext, onGetNav } = this.props;

    // Setup zola secondary nav
    window.zolaNav = window.zolaNav || {};
    if (window.zolaNav.secondaryNavType !== '') {
      window.zolaNav.secondaryNavType = 'registry';
    }
    onGetNav().then((nav) => this.setState({ nav }));

    // Get user context
    if (!user) {
      getUserContext();
    }
    window.addEventListener('resize', this.refreshNavHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.refreshNavHeight);
  }

  refreshNavHeight() {
    const { height } = this.state;
    const newHeight = window.innerWidth < 992 ? 60 : 110;
    if (height !== newHeight) {
      this.setState({ height: newHeight });
    }
  }

  render() {
    const { styleOverride } = this.props;
    const { nav, height } = this.state;
    const styleObject = Object.assign(
      {},
      {
        zIndex: 500,
        height,
        transform: 'none',
        backgroundColor: '#FFFFFF',
      },
      styleOverride
    );
    return (
      <Sticky style={styleObject}>
        <UnifiedNavHtmlLoader html={nav} />
      </Sticky>
    );
  }
}

UnifiedNav.propTypes = {
  user: PropTypes.shape({}),
  getUserContext: PropTypes.func.isRequired,
  onGetNav: PropTypes.func.isRequired,
  styleOverride: PropTypes.shape({
    height: PropTypes.number,
    backgroundColor: PropTypes.string,
    zIndex: PropTypes.number,
  }),
};

UnifiedNav.defaultProps = {
  user: null,
};

const mapStateToProps = (state) => ({
  user: state.user.userContext,
});

const mapDispatchToProps = (dispatch) => ({
  getUserContext: () => dispatch(UserActions.getUserContext()),
  onGetNav: () => dispatch(getNav()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnifiedNav);
